module.exports = __webpack_public_path__ + "static/media/bombshell.c5cc313d.png";